import React from 'react';
import { Routes, Route } from "react-router-dom";

import NonAuthLayout from "../layout/NonAuthLayout";

import { authProtectedRoutes, publicRoutes } from "./Routes";
import { AuthProtected } from './AuthProtected';
import KycGuard from './KycGuard';

const Index = () => {

    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>
                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    <KycGuard>
                                        {route.component}
                                    </KycGuard>                                   
                                </AuthProtected>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default Index;